var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.55 26.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#517199;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Derek_Skrzynski",
    "data-name": "Derek Skrzynski"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back_-_color_copy_3",
    "data-name": "Back - color copy 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACD_copy_7",
    "data-name": "ACD copy 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.18,5.6a10.2,10.2,0,0,0-3.69-3.69A9.83,9.83,0,0,0,53.43.54H44.18V25.6h1.33V1.87H53.4a8.63,8.63,0,0,1,4.41,1.19A8.9,8.9,0,0,1,61,6.26a8.54,8.54,0,0,1,1.18,4.4v4.82A8.5,8.5,0,0,1,61,19.87a8.93,8.93,0,0,1-3.22,3.21,8.63,8.63,0,0,1-4.41,1.18H48.58V25.6h4.85a9.83,9.83,0,0,0,5.06-1.37,10.2,10.2,0,0,0,3.69-3.69,9.83,9.83,0,0,0,1.37-5.06V10.66A9.8,9.8,0,0,0,62.18,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.43,20.41a9.14,9.14,0,0,0,3.24,3.21,8.63,8.63,0,0,0,4.41,1.18,9.87,9.87,0,0,0,4.43-1,7.76,7.76,0,0,0,3.12-2.7,7.26,7.26,0,0,0,1.17-3.89h1.29a8.18,8.18,0,0,1-1.31,4.52A9.19,9.19,0,0,1,37.18,25a11,11,0,0,1-5.1,1.17A9.89,9.89,0,0,1,27,24.77a10.18,10.18,0,0,1-3.71-3.69A9.83,9.83,0,0,1,21.93,16v-5.9a9.88,9.88,0,0,1,1.35-5.06A10.14,10.14,0,0,1,27,1.37,9.83,9.83,0,0,1,32,0a11,11,0,0,1,5.06,1.17,9.37,9.37,0,0,1,3.62,3.2A8.08,8.08,0,0,1,42,8.89h-1.3A7.12,7.12,0,0,0,39.54,5a7.89,7.89,0,0,0-3.12-2.7,9.92,9.92,0,0,0-4.41-1,8.51,8.51,0,0,0-4.39,1.19,8.92,8.92,0,0,0-3.2,3.2,8.45,8.45,0,0,0-1.19,4.4V16A8.43,8.43,0,0,0,24.43,20.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.3.54h1.4L22,25.6H20.56l-3.39-8.28H7.23L7.78,16h8.85L11,2.27,1.4,25.6H0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcd);
export default __webpack_public_path__ + "static/media/ACD.8b2c2b18e973e34dd979e23030c70088.svg";
export { ForwardRef as ReactComponent };